import { render, staticRenderFns } from "./serviceProject.vue?vue&type=template&id=211eed66&scoped=true&"
import script from "./serviceProject.vue?vue&type=script&lang=js&"
export * from "./serviceProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211eed66",
  null
  
)

export default component.exports